const canRenderImageType = (type) => {
  const canvas = document.createElement('canvas')
  return canvas.toDataURL(type).indexOf(`data:${type}`) === 0
}

export default canRenderImageType
